import { config } from 'config';
import { sendMultiPartRequest, sendRequest } from 'services/base/sendRequest';
import { parseFetchError } from 'utils/http';
import { appConfig } from '../../config/app';

const sendAssessmentRequest = data => {
  const serviceUrl =
    config.serverURL +
    appConfig.api_routes.prefix +
    appConfig.api_routes.modules.conciliation.prefix +
    appConfig.api_routes.modules.conciliation.services.assessmentRequest;

  let formData = new FormData();

  formData.append('userType', data.userType);
  formData.append('companyType', data.companyType);
  formData.append('companyName', data.companyName);
  formData.append('companyNIT', data.companyNIT);
  formData.append('companyAddress', data.companyAddress);
  formData.append('companyCity', JSON.stringify(data.companyCity));
  formData.append('companyEmail', data.companyEmail);
  formData.append('companyPhoneNumber', data.companyPhoneNumber);

  formData.append('documentType', JSON.stringify(data.documentType));
  formData.append('documentNumber', data.documentNumber);
  formData.append('firstName', data.firstName);
  formData.append('lastName', data.lastName);
  formData.append('address', data.address);
  formData.append('email', data.email);
  formData.append('homePhoneNumber', data.homePhoneNumber);
  formData.append('cellphoneNumber', data.cellphoneNumber);
  formData.append('officePhoneNumber', data.officePhoneNumber);
  formData.append('contactPhoneNumber', data.contactPhoneNumber);
  formData.append('sex', JSON.stringify(data.sex));
  formData.append('maritalStatus', JSON.stringify(data.maritalStatus));
  formData.append('stratum', JSON.stringify(data.stratum));
  formData.append('scholarship', JSON.stringify(data.scholarship));
  formData.append('occupation', JSON.stringify(data.occupation));
  formData.append('city', JSON.stringify(data.city));
  formData.append('housing', data.housing);
  formData.append('vehicle', data.vehicle);
  formData.append('matter', JSON.stringify(data.matter));
  formData.append('acts', data.acts);
  formData.append('claims', data.claims);

  if (data.providedEvidenceList) {
    let docNames = '';
    data.providedEvidenceList.forEach((doc, index) => {
      docNames += doc.name + ',';
      formData.append('document', doc.file);
    });
    console.log('docNames: ' + docNames);
    formData.append(
      'evidenceDocNames',
      docNames.substring(0, docNames.length - 1),
    );
    formData.append('evidenceListSize', data.providedEvidenceList.length);
  }

  return sendMultiPartRequest(serviceUrl, formData);
};

const conciliationRequest = data => {
  const serviceUrl =
    config.serverURL +
    appConfig.api_routes.prefix +
    appConfig.api_routes.modules.conciliation.prefix +
    appConfig.api_routes.modules.conciliation.services.conciliationRequest;

  let formData = new FormData();

  formData.append('id', data.id);
  if (data.acts && data.acts !== '') {
    formData.append('acts', data.acts);
  }
  if (data.claims && data.claims !== '') {
    formData.append('claims', data.claims);
  }
  if (data.attorney) {
    formData.append('attorney', JSON.stringify(data.attorney));
  }
  formData.append('convenedList', JSON.stringify(data.convenedList));

  if (data.providedEvidenceList) {
    let docNames = '';
    data.providedEvidenceList.forEach((doc, index) => {
      docNames += doc.name + ',';
      formData.append('document', doc.file);
    });
    console.log('docNames: ' + docNames);
    formData.append(
      'evidenceDocNames',
      docNames.substring(0, docNames.length - 1),
    );
    formData.append('evidenceListSize', data.providedEvidenceList.length);
  }
  formData.append('paymentTicket', data.paymentTicket);

  return sendMultiPartRequest(serviceUrl, formData);
};

const requestView = id => {
  return new Promise(async (resolve, reject) => {
    try {
      const serviceUrl =
        config.serverURL +
        appConfig.api_routes.prefix +
        appConfig.api_routes.modules.conciliationAdmin.prefix +
        appConfig.api_routes.modules.conciliationAdmin.services.view;

      let formData = new FormData();
      formData.append('id', id);

      const dataOut = sendMultiPartRequest(serviceUrl, formData);
      resolve(dataOut);
    } catch (e) {
      reject({
        respCode: -1,
        message: parseFetchError(e),
      });
    }
  });
};

const view = registrationNumber => {
  const serviceUrl =
    config.serverURL +
    appConfig.api_routes.prefix +
    appConfig.api_routes.modules.documents.prefix +
    appConfig.api_routes.modules.documents.services.personDocuments;

  return sendRequest(
    serviceUrl,
    { registrationNumber: registrationNumber },
    true,
  );
};

export { sendAssessmentRequest, conciliationRequest, requestView, view };
